import { East } from '@mui/icons-material';
import { Grid } from '@mui/material';
import ControlledDatePicker from 'src/shared/components/form/controlledDatePicker';

type MemberAdvancedSearchDateRangeProps = {
  dateStartPropName: string;
  dateStartLabel: string;
  dateEndPropName: string;
  dateEndLabel: string;
};

export const MemberAdvancedSearchDateRange = (props: MemberAdvancedSearchDateRangeProps) => {
  const { dateStartPropName, dateStartLabel, dateEndPropName, dateEndLabel } = props;
  return (
    <Grid
      container
      spacing={0.25}
      sx={{
        alignItems: 'center',
        '& .MuiIconButton-sizeMedium': {
          color: (thm) => thm.palette.grey[500],
          '&:hover': { color: (thm) => `${thm.palette.grey[800]} !important` },
        },
      }}
    >
      <Grid item xs>
        <ControlledDatePicker name={dateStartPropName} label={dateStartLabel} />
      </Grid>
      <Grid item xs='auto'>
        <East sx={{ color: (thm) => thm.palette.grey[400], mt: 1 }} />
      </Grid>
      <Grid item xs>
        <ControlledDatePicker name={dateEndPropName} label={dateEndLabel} />
      </Grid>
    </Grid>
  );
};
